import React from 'react';

export const VideoPlayer = ({ video, className = '', autoPlay = false, testId }) => (
  <video className={className} poster={video.poster} controls playsInline autoPlay={autoPlay} preload="metadata" data-testid={testId}>
    {video.webm && <source src={video.webm} type="video/webm" />}
    <source src={video.src} type="video/mp4" />
  </video>
);
